import React , {useState , useEffect} from 'react';
import { fetchTotalDealer } from '../../stores/api_calls/dashboard';
import {
    FaBuysellads,
  } from "react-icons/fa";
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const TotalDealer = () => {

    const navigate = useNavigate()
    const [totalDealer , setTotalDealer] = useState()
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true)
        const getTotalDealer = fetchTotalDealer()

        getTotalDealer.then((res)=>{
            if(res.data){
                if(res.data.success){
                    // console.log(res.data.data);
                    setTotalDealer(res.data.data)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='total-banner header-card'>
                <p className='header-text'>Dealer</p>
                <FaBuysellads style={{width:"80px"}}/>
            </div>
            <div className='total-banner body-card'>
                <p className='active-text'>Total : {isLoading ? 'fetching' : !isLoading&&totalDealer? totalDealer : 0}</p>
                <div className='goIcon' onClick={()=>navigate("../dealers", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default TotalDealer;
